
<template>
  <div style="width: 100%; height: 100%; position: fixed; top: 0; left: 0; background: #e5e5e5; z-index: 5;">
    <div style="width: 100%; height: 70px; background: #f7f7f7; padding: 10px; font-weight: bold; font-size: 18px;">
      {{product.title}}

    </div>
    <div style="width: 100%; height: calc(100% - 140px); overflow-y: auto;">
      <div class="container pt-0">
        <div class="row pt-0">
          <div class="col-12 pt-0">
            <div class="inventory-card" v-for="inv in inventories" :key="'product-' + product.id + '-inventory-' + inv.id" @click="openInventoryItemView(product, inv)">
              <div style="width: 100%; display: flex;">
                <div class="inv-location text-center" style="width: 50%;">
                  {{inv.area}} - {{inv.location}} - {{inv.section}}
                </div>
                <div class="inv-title" style="width: 50%;">
                  #{{inv.id}}
                </div>

              </div>


              <div class="inv-balance" style="background: #d3ffd3;">
                <div style="width: 50%;background: #fff0f0; padding-top: 5px;">
                  <div class="inv-description">
                    Batch Code: {{inv.batchCode}}

                  </div>
                  <div class="inv-description">
                    Expiry: {{inv.expiryDate}}
                  </div>
                </div>
                <div class="cur-bal text-center">
                  <div style="font-size: medium;">Current Stock</div>
                  <div style="font-size: 50px;">
                  {{inv.balance}}
                  </div>
                </div>
<!--                <div class="cur-bal" style="font-size: 30px; padding-top: 40px; text-align: right; padding-right: 10px;">-->
<!--                  <span style="font-size: medium; padding-left: 10px;">from</span> {{inv.originalBalance}}-->
<!--                </div>-->
              </div>

              <div class="inv-balance text-center" style="background: #ffdcd3; padding: 10px; display: none;">
                <div>
                  Unit Price:
                  <div class="inv-price">
                    {{inv.unitPriceFloat.toFixed(2)}}
                  </div>

                </div>

                <div>
                  Value:
                  <div class="inv-price">
                    {{inv.valueFloat.toFixed(2)}}
                  </div>
                </div>

              </div>
              <div class="inv-tile" style="padding: 10px; text-align: right;">
                {{inv.originalBalance}} Stocked in at {{getTimeString(inv.stockInTime)}}
              </div>
              <!--                  <div class="inv-detail">-->
              <!--                    <div>-->
              <!--                      {{inv.inQuantity}}-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      {{inv.outQuantity}}-->
              <!--                    </div>-->

              <!--                  </div>-->
              <div class="container pt-0">
                <div class="row pt-0">
                  <div class="col-6 pt-0">
                    <button class="wms-button wms-blue-button" @click="openChangeLocationForm(inv)">Change Location</button>
                  </div>
                  <div class="col-6 pt-0">
                    <button class="wms-button wms-green-button" @click="openMoveForm(inv)">Partial Move</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div style="width: 100%; height: 70px; line-height: 70px; padding-left: 10px; background: #f7f7f7; display: flex;">
      <div style="width: 50%; height: 70px; line-height: 70px; padding-left: 15px;">
        <span style="font-size: 30px; font-weight: bold;">Total {{product.currentStock}}</span> stocks
      </div>

      <div style="width: 50%; height: 70px; line-height: 70px; text-align: right; padding-right: 15px;">
        <button class="btn btn-dark" @click="closeView">CLOSE</button>
      </div>

    </div>
    <div v-if="changeLocationForm !== false" style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 10;" @click="closeChangeLocationForm">
      <div style="position: absolute; top: 20px; left: 10px; background: white; width: calc(100% - 20px); padding: 50px 10px; height: calc(100% - 200px);" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Change Location
            </div>
          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-12">
              Current Location
            </div>

            <div class="col-4">
              Area
              <label class="form-control">{{changeLocationForm.item.area}}</label>
            </div>
            <div class="col-4">
              Location
              <label class="form-control">{{changeLocationForm.item.location}}</label>
            </div>
            <div class="col-4">
              Section
              <label class="form-control">{{changeLocationForm.item.section}}</label>
            </div>
          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-12">
              New Location
            </div>
            <div class="col-4">
              Area

              <select v-model="changeLocationForm.area" class="form-control">
                <option value="">Select</option>
                <option v-for="a in areas" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Location
              <select v-model="changeLocationForm.location" class="form-control">
                <option value="">Select</option>
                <option v-for="a in locations" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Section
              <select v-model="changeLocationForm.section" class="form-control">
                <option value="">Select</option>
                <option v-for="a in sections" :value="a">{{a}}</option>
              </select>
            </div>
          </div>

          <div class="row" style="padding-top: 50px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeChangeLocationForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitChangeLocationForm">CHANGE</button>
            </div>
          </div>
        </div>
      </div>

    </div>



    <div v-if="moveForm !== false" style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closeMoveForm">
      <div style="position: absolute; top: 20px; left: 10px; background: white; width: calc(100% - 20px); padding: 10px 10px; height: calc(100% - 40px); overflow-y: scroll;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Move Stocks
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-6">
              Current Stock <br/><span class="inventory-large">{{moveForm.item.balance}}</span>
            </div>
            <div class="col-6 text-left">
              Current Location <br/><span class="inventory-medium">{{moveForm.item.area}} - {{moveForm.item.location}} - {{moveForm.item.section}}</span>
            </div>

          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-6 text-left" style="line-height: 40px;">
              <b>How many to move</b> (up to {{moveForm.item.balance -1}})
            </div>
            <div class="col-6">
              <input class="form-control text-center" v-model="moveForm.newBalance" style="height: 40px; line-height: 40px; font-size: 30px;"/>
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-12 text-left">
              <b>New Location</b>
            </div>
            <div class="col-4">
              Area

              <select v-model="moveForm.area" class="form-control">
                <option value="">Select</option>
                <option v-for="a in areas" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Location
              <select v-model="moveForm.location" class="form-control">
                <option value="">Select</option>
                <option v-for="a in locations" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Section
              <select v-model="moveForm.section" class="form-control">
                <option value="">Select</option>
                <option v-for="a in sections" :value="a">{{a}}</option>
              </select>
            </div>

          </div>

          <div class="row" style="padding-top: 20px;">
            <div class="col-12 text-left">
              <b>Will this inventory to stock out</b> before or after than this inventory?
            </div>
            <div class="col-6">
              <button class="selector-btn" :class="{'selected': moveForm.timeDiff === -1000}" @click="moveForm.timeDiff = -1000">Before</button>
            </div>
            <div class="col-6">
              <button class="selector-btn" :class="{'selected': moveForm.timeDiff === 1000}" @click="moveForm.timeDiff = 1000">After</button>
            </div>
          </div>
          <div class="row" style="padding-top: 20px; border-top: 1px solid #ccc; margin-top: 40px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeMoveForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitMoveForm">MOVE <span v-if="moveForm.newBalance > 0">{{moveForm.newBalance}}</span></button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {changeInventoryInventory, getWmsProductInventories, moveInventoryInventory} from "../api/wms";
import {
  getAreaList,
  getLocationList,
  getSectionList,
  millisToMMDDHHMM,
  showDialog,
  timeToLocaleDateYear
} from "../api/utils";

export default {
  name: 'WmsProductView',
  props:{
    product: {
      type: Object,
      default: function (){return null;}
    },
    onClose: {
      type: Function,
      default: null,
    },
    onUpdated: {
      type: Function,
      default: null,
    },

  },
  data() {
    return {
      inventories:[],
      moveForm:false,
      changeLocationForm:false,
      areas:getAreaList(),
      locations: getLocationList(),
      sections: getSectionList(),
    }
  },
  created() {
  },
  mounted() {
    this.initialise();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    dummy: function() {

    },
    initialise: function() {
      this.getInventoryList();
    },
    getTimeString:timeToLocaleDateYear,
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    getInventoryList: function() {
      let self = this;
      getWmsProductInventories(this.product.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.inventories = data.inventories;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ' )';
          }
          showDialog(msg, "ERROR at getting inventory list");
        })
    },
    openInventoryItemView: function(product, inventory) {

    },
    openChangeLocationForm: function(item) {
      this.$data.changeLocationForm = {
        id: item.id,
        item:item,
        area:'',
        location:'',
        section:'',
      }
    },
    closeChangeLocationForm: function() {
      this.$data.changeLocationForm = false;
    },
    submitChangeLocationForm: function() {


      let self = this;
      changeInventoryInventory(this.$data.changeLocationForm)
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < self.$data.inventories.length ; i++) {
              if(self.$data.inventories[i].id === data.inventory.id) {
                self.$data.inventories.splice(i, 1, data.inventory)
              }
            }
            // self.item.area = data.inventory.area;
            // self.item.location = data.inventory.location;
            // self.item.section = data.inventory.section;
            // self.item.updatedTime = data.inventory.updatedTime;

            self.$data.changeLocationForm = false;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ' )';
          }
          showDialog(msg, "ERROR")
        })
    },

    openMoveForm: function(item) {
      this.$data.moveForm = {
        item:item,
        sourceId: item.id,
        area:'',
        location:'',
        section:'',
        newBalance:0,
        timeDiff:0,
      }
    },
    closeMoveForm: function() {
      this.$data.moveForm = false;
    },
    submitMoveForm: function() {
      if(this.$data.moveForm.area === '' || this.$data.moveForm.location === '' || this.$data.moveForm.section === '') {
        showDialog("Please select location");
        return;
      }
      if(this.$data.moveForm.newBalance === 0) {
        showDialog("Please select quantity to move");
        return;
      }

      if(this.$data.moveForm.newBalance >= this.$data.moveForm.item.balance) {
        showDialog("Quantity to move should be less than current stock balance " + this.$data.moveForm.item.balance);
      }

      let self = this;
      moveInventoryInventory(this.$data.moveForm)
        .then(function(data){
          if(data.success === true) {
            for(let j = 0 ; j < data.inventories.length ; j++) {
              let found = false;
              for (let i = 0; i < self.$data.inventories.length; i++) {
                if (self.$data.inventories[i].id === data.inventories[j].id) {
                  self.$data.inventories.splice(i, 1, data.inventories[j])
                  found = true;
                }
              }
              if(found === false) {
                self.$data.inventories.push(data.inventories[j]);
              }
            }
            self.$data.moveForm = false;
          } else {
            showDialog(data.message, "Failed to move");
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at moving inventory");
        })

    },
  }
}
</script>

<style scoped>
.inventory-card {
  margin-top: 10px;
  background: white;
  border-radius: 10px;
  border: 1px solid #2a90e9;
  overflow: hidden;

}
.inv-title{
  font-size: 20px;
  background: #eee;
  font-weight: bold;
  padding: 0 10px;
  text-align: right;
}
.inventory-card .inv-balance {
  width: 100%;
  display: flex;
}
.inv-balance > div {
  width: 50%;
}
.inv-balance .cur-bal {
  font-size: 70px;
  font-weight: bold;
}
.inv-balance .inv-price {
  font-size: 20px;
  font-weight: bold;
}
.wms-button {
  padding: 10px;
  width: 100%;
  text-align: center;
}
.wms-blue-button {
  background: #bfd2f0;

}
.wms-green-button {
  background: #ace5b4;

}
.selector-btn {
  width: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  font-size: 15px;
}
.selector-btn.selected {
  background: blue;
  color: white;
  font-weight: bold;
}
.inv-location {
  font-size: 30px;
  font-weight: bold;
  padding: 0 10px;
}
.inv-description {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/WmsProductView.vue